import script from "./HeaderComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderComponent.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderComponent.vue?vue&type=style&index=0&id=471b400a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-471b400a"]])

export default __exports__